import { http } from './base-http';

export interface IUserEventData {
  type: string;
  control: string;
  properties: Record<string, unknown>;
}

export const sendUserEventApi = (params: IUserEventData) => http.post(`/api/v1/user-event`, params);
